import React from 'react';
import Card from '../Card';
import { selectIsMyTurn } from '../../../redux/gameSlice';
import { useSelector } from 'react-redux';

export default function BuyCardAnimated(props) {
  const isMyTurn = useSelector(selectIsMyTurn);

  if (isMyTurn) {
    return <div className="mimic-buy-card-overlay buying-card">
      <Card type={props.cardType} animating={true} movementType="buying-card-my-player" />
    </div>
  }

  return <>
    <div className="mimic-buy-card-overlay buying-card">
      <Card type={props.cardType} animating={true} movementType="buying-card-other-player" />
    </div>
    <div className={`game-sprite effect-ball card card-bought-ball-flying-player-${props.toPlayerIdx + 1}`}></div>
  </>;
}
